import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux'; // eslint-disable-line no-restricted-imports

// This function will map the current redux state to the props for the component that it is "connected" to.
// When the state of the redux store changes, this function will be called, if the props that come out of
// this function are different, then the component that is wrapped is re-rendered.
const mapStateToProps = ({ user }: any) => ({
  // TODO (piers) Agree method of passing through locale setting for ads
  locale: user.locale.localeId,
  messages: user.locale.msg,
});

export default connect(mapStateToProps)(IntlProvider);
